import getIn from 'immutable-less/transmute/getIn';
import LogEventKeys from 'automation-ui-log-events/constants/LogEventKeys';
export const fromContextMap = logEvent => prop => getIn([LogEventKeys.CONTEXT_MAP, prop], logEvent);
export const getExecutionCounts = logEvent => {
  const getFromContextMap = fromContextMap(logEvent);
  const successCount = getFromContextMap('NUM_SUCCESSFUL_ASSOCIATED_EXECUTIONS') || 0;
  const failCount = getFromContextMap('NUM_FAILED_ASSOCIATED_EXECUTIONS') || 0;
  const totalCount = successCount + failCount;
  return {
    successCount,
    failCount,
    totalCount
  };
};
export const getEventAnchor = logEvent => {
  const getFromContextMap = fromContextMap(logEvent);
  return {
    contactPropertyAnchor: getFromContextMap('CLASSIC_ANCHORED_DELAY_CONTACT_PROPERTY_ANCHOR') || undefined,
    staticDateAnchor: getFromContextMap('CLASSIC_ANCHORED_DELAY_STATIC_DATE_ANCHOR') || undefined
  };
};
export const getClassicTrigger = logEvent => fromContextMap(logEvent)('CLASSIC_TRIGGER');
export const getClassicTriggerId = logEvent => fromContextMap(logEvent)('CLASSIC_TRIGGER_ID');
export const getClassicTriggerMatchedFrom = logEvent => fromContextMap(logEvent)('CLASSIC_TRIGGER_MATCHED_FROM');
export const getEnrollmentAppId = logEvent => fromContextMap(logEvent)('APP_ID');
export const getAcceptedListId = logEvent => fromContextMap(logEvent)('ACCEPTED_LIST_ID');
export const getAcceptedBranchValue = logEvent => fromContextMap(logEvent)('ACCEPTED_BRANCH_VALUE');
export const getAcceptedBranchOperator = logEvent => fromContextMap(logEvent)('ACCEPTED_BRANCH_OPERATOR');
export const getAcceptedConnectionIndex = logEvent => fromContextMap(logEvent)('ACCEPTED_CONNECTION_INDEX');
export const getCreatedObjectId = logEvent => fromContextMap(logEvent)('CREATED_OBJECT_ID');
export const getAssignedOwnerId = logEvent => fromContextMap(logEvent)('ASSIGNED_OWNER_ID');
export const getRecipientEmails = logEvent => fromContextMap(logEvent)('RECIPIENT_EMAILS');
export const getWebhookResponseBody = logEvent => fromContextMap(logEvent)('WEBHOOK_RESPONSE_BODY');
export const getWebhookStatusCode = logEvent => fromContextMap(logEvent)('WEBHOOK_STATUS_CODE');
export const getMissingProperties = logEvent => fromContextMap(logEvent)('MISSING_PROPERTIES');
export const getInvalidProperties = logEvent => fromContextMap(logEvent)('INVALID_PROPERTIES');
export const getSalesforceUrl = logEvent => fromContextMap(logEvent)('SALESFORCE_URL');
export const getSalesforceOwnerName = logEvent => fromContextMap(logEvent)('SALESFORCE_OWNER_NAME');
export const getWorkflowId = logEvent => fromContextMap(logEvent)('WORKFLOW_ID');
export const getSourceFlowId = logEvent => fromContextMap(logEvent)('SOURCE_FLOW_ID');
export const getClassicLogEvent = logEvent => fromContextMap(logEvent)('CLASSIC_LOG_EVENT');
export const getDeferredTimestamp = logEvent => fromContextMap(logEvent)('DEFERRED_TIMESTAMP');
export const getActionExpired = logEvent => fromContextMap(logEvent)('ACTION_EXPIRED');
export const getIsClassicTest = logEvent => fromContextMap(logEvent)('IS_CLASSIC_TEST');
export const getUserId = logEvent => fromContextMap(logEvent)('USER_ID');
export const getListId = logEvent => fromContextMap(logEvent)('LIST_ID');
export const getChatflowId = logEvent => fromContextMap(logEvent)('CHATFLOW_ID');
export const getHistoryMessage = logEvent => fromContextMap(logEvent)('HISTORY_MESSAGE');
export const getPropertyValue = logEvent => fromContextMap(logEvent)('PROPERTY_VALUE');
export const getIsRepeatPropertyValue = logEvent => fromContextMap(logEvent)('IS_REPEAT_PROPERTY_VALUE');